import React from 'react';
import { Box, Sprout, Droplets, Package, FileText, Video } from 'lucide-react';

interface WhatsIncludedProps {
  title?: string;
  subtitle?: string;
  items: Array<{
    icon: 'box' | 'sprout' | 'droplets' | 'package' | 'filetext' | 'video';
    title: string;
    description: string;
  }>;
  setupTime?: string;
}

const ICON_MAP = {
  box: Box,
  sprout: Sprout,
  droplets: Droplets,
  package: Package,
  filetext: FileText,
  video: Video
};

export default function WhatsIncluded({
  title = "What's Inside Your Grow Box",
  subtitle = "Everything you need. Nothing you don't.",
  items,
  setupTime
}: WhatsIncludedProps) {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            {title}
          </h2>
          <p className="text-lg text-gray-600">
            {subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-8">
          {items.map((item, index) => {
            const IconComponent = ICON_MAP[item.icon];
            return (
              <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow">
                <div className="flex flex-col items-center text-center">
                  <div className="bg-primary-100 p-4 rounded-full mb-4">
                    <IconComponent className="h-8 w-8 text-primary-600" />
                  </div>
                  <h3 className="font-bold text-lg mb-2">{item.title}</h3>
                  <p className="text-gray-600 text-sm">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {setupTime && (
          <div className="text-center">
            <p className="text-lg font-semibold text-primary-600">
              {setupTime}
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
